module.exports = __webpack_public_path__ + "static/Grupo 67-126d3706b4f9c802ecf437e443d4bae3.svg";